import React, { useState, useContext, useEffect } from "react";
import { Col, Row, Form, Breadcrumb } from '@themesberg/react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Routes } from "../../../routes";
import { CatalogCardClient } from "../cards/orders/catalogCard";
import axios from '../../../config/axios';
import { Context } from "../../../context/Context";
import FloatingCart from '../../widgets/FloatingCart';

const Order = () => {
  const navigate = useNavigate();
  const { order_id } = useParams();
  const [auth] = useContext(Context);

  const [filters, setFilters] = useState({
    searchTerm: "",
    channel: "",
    state: "",
    productType: "",
    status: "",
  });

  const [priceLists, setPriceLists] = useState([]);
  const [selectedPriceListId, setSelectedPriceListId] = useState(null);

  const handleNavigate = () => {
    navigate(Routes.Orders.path);
  };

  useEffect(() => {
    const fetchPriceLists = async () => {
      if (auth.role === 'client' && !auth.sync) return;

      try {
        const response = await axios.get(`/pricelist/list/user/${auth.id}`);
        const lists = response.data.rows;

        setPriceLists(lists);
        const defaultList = lists.find(list => list.default);
        if (defaultList) {
          setSelectedPriceListId(defaultList.id);
        }
      } catch (error) {
        console.error("Error al obtener listas de precios:", error);
      }
    };

    fetchPriceLists();
  }, [auth.id, auth.sync, auth.role]);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0 mr-0">
          <Breadcrumb className="title-page" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Toppo</Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => handleNavigate()}>Pedidos</Breadcrumb.Item>
            <Breadcrumb.Item active>Crear Pedido</Breadcrumb.Item>
          </Breadcrumb>
          <h4 className="title-page">Crear pedido</h4>
          <p className="mb-0">Aquí podrás crear un pedido.</p>
          <FloatingCart />
        </div>
      </div>

      {!(auth.role === 'client') && (
        <Row className="mb-4">
          <Col xs={12} md={6} lg={4}>
            <Form.Label>Lista de precios:</Form.Label>
            <Form.Select
              value={selectedPriceListId || ""}
              onChange={(e) => setSelectedPriceListId(Number(e.target.value))}
            >
              {priceLists.map((list) => (
                <option key={list.id} value={list.id}>
                  {list.name}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      )}

      <CatalogCardClient
        searchTerm={filters.searchTerm}
        channel={filters.channel}
        state={filters.state}
        product_type={filters.productType}
        status={filters.status}
        price_list_id={selectedPriceListId}
      />
    </>
  );
};

export default Order;
